import { setup } from 'twind'
import config from '../../tailwind.config'

function initTheme() {
  const openSansUrl = `url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,700;1,400&display=swap')`

  setup({
    ...config,
    hash: true,
    darkMode: 'class',
    preflight: {
      '@import': openSansUrl,
    },
    mode: process.env.NODE_ENV === 'production' || 'test' ? 'silent' : 'warn',
  })
}

export default initTheme
